import React from 'react';
import { Link } from 'react-router-dom';

interface ShadowButtonProps {
  children: React.ReactNode;
  to?: string; // For Link routing
  href?: string; // For external links
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const ShadowButton: React.FC<ShadowButtonProps> = ({
  children,
  to,
  href,
  className = '',
  onClick,
  fullWidth = false,
  type = 'button'
}) => {
  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.boxShadow = '4px 8px 0 0 #000';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.boxShadow = '2px 4px 0 0 #000';
  };

  const buttonClasses = `${fullWidth ? 'w-full' : ''} bg-white text-black border-black border-2 px-6 py-3 rounded-md font-medium ${className}`;
  
  const buttonStyle = {
    boxShadow: '2px 4px 0 0 #000',
  };

  const buttonElement = (
    <button
      type={type}
      className={buttonClasses}
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </button>
  );

  // Render different wrappers based on the props
  if (to) {
    return <Link to={to} className={fullWidth ? 'w-full sm:w-auto' : 'sm:w-auto'}>{buttonElement}</Link>;
  } else if (href) {
    return <a href={href} className={fullWidth ? 'w-full sm:w-auto' : 'sm:w-auto'}>{buttonElement}</a>;
  } else {
    return buttonElement;
  }
};

export default ShadowButton;